<div class="container-fluid">
  <!-- Media strip. Videos first and rendered as real players — on Jowa the
       video IS the profile, and a reviewer has to be able to watch it here
       rather than guess from a still. Every status is shown, so a profile
       stuck in transcoding or turned away by moderation explains itself. -->
  <div class="container-fluid d-flex profile-media-strip">
    <sa-profile-video-tile *ngFor="let video of videos" class="m-1"
                           size="card" [video]="video" [siblings]="videos"
                           [title]="displayName"></sa-profile-video-tile>

    <figure class="profile-photo m-1" *ngFor="let profile_image of user.profile_images; let i = index">
      <img [src]="profile_image.image_url" class="rounded profile-image" alt="...">
      <figcaption class="photo-meta">
        <span class="meta-kind">Photo</span>
        <span class="meta-slot">Slot {{ profile_image.place }}</span>
      </figcaption>
    </figure>

    <p class="profile-media-empty" *ngIf="!videos.length && !user.profile_images?.length">
      This profile has no photos or videos.
    </p>
  </div>
  <div class="w-100 px-3 pt-3">
    <sa-timezone-toggle></sa-timezone-toggle>
  </div>
  <mat-accordion class="example-headers-align m-2" [multi]="true">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Notes
        </mat-panel-title>
        <mat-panel-description>
          <mat-icon>notes</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid">
        <sa-editable-textfield label="Admin Notes" [value]="user.admin_notes" (valueChanged)="notesValueChanged($event)"></sa-editable-textfield>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Personal Info
        </mat-panel-title>
        <mat-panel-description>
          <mat-icon>face</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid">
        <sa-info-field label="User ID">
          {{ user.user_id }}
        </sa-info-field>
        <sa-info-field label="First Name">
          {{ user.name }}
        </sa-info-field>
        <sa-info-field label="Last Name">
          {{ user.lastname }}
        </sa-info-field>
        <sa-info-field label="Verified">
          <div *ngIf="user.is_verified"><b>Yes</b></div>
          <div *ngIf="!user.is_verified">No</div>
          <sa-verification-session-inline class="mt-4" [verificationSessionId]="user.last_verification_session_id" *ngIf="user.last_verification_session_id" ></sa-verification-session-inline>
        </sa-info-field>
        <sa-info-field label="Rating">
          {{ user.popularity_score }}
        </sa-info-field>
        <sa-info-field label="Phone Number">
          {{ user.phone_number }}
        </sa-info-field>
        <sa-info-field label="Phone Number Country">
          {{ user.phone_number_cc }}
        </sa-info-field>
        <sa-info-field label="Phone Number Carrier">
          {{ user.phone_number_carrier }}
        </sa-info-field>
        <sa-info-field label="Email">
          {{ user.email }}
        </sa-info-field>
        <sa-info-field label="Login Method">
          {{ user.login_method | loginMethodLabel }}
        </sa-info-field>
        <sa-info-field label="Status">
          {{ user.active ? 'Active' : 'Inactive'}}
        </sa-info-field>
        <sa-info-field label="Premium User">
          {{ user.is_premium ? 'Yes' : 'No'}}
        </sa-info-field>
        <sa-info-field label="Select User">
          {{ user.is_select ? 'Yes' : 'No'}}
        </sa-info-field>
        <sa-info-field label="Gender">
          {{ user.gender }}
        </sa-info-field>
        <sa-info-field label="Birth Date">
          {{ user.birth }}
        </sa-info-field>
        <sa-info-field label="Facebook ID">
          {{ user.fid }}
        </sa-info-field>
        <sa-info-field label="Facebook Access Token">
          {{ user.fb_access_token }}
        </sa-info-field>
        <sa-info-field label="Firebase UID">
          {{ user.firebase_uid }}
        </sa-info-field>
        <sa-info-field label="Last Activity ({{ timezoneAbbr }})">
          {{ user.last_activity | timezoneDate }}
        </sa-info-field>
        <sa-info-field label="Last IP">
          {{ user.last_ip }}
        </sa-info-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Device & App
        </mat-panel-title>
        <mat-panel-description>
          <mat-icon>smartphone</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid">
        <sa-info-field label="Operating System">
          {{ user.platform }}
        </sa-info-field>
        <sa-info-field label="OS Version">
          {{ user.os_version }}
        </sa-info-field>
        <sa-info-field label="App Version">
          {{ user.app_version }}
        </sa-info-field>
        <sa-info-field label="Build Number">
          {{ user.build_number }}
        </sa-info-field>
        <sa-info-field label="Device Model">
          {{ user.device_model }}
        </sa-info-field>
        <sa-info-field label="Device Manufacturer">
          {{ user.device_manufacturer }}
        </sa-info-field>
        <sa-info-field label="Legacy Device Type">
          {{ user.device_type }}
        </sa-info-field>
        <sa-info-field label="FCM Token">
          {{ user.gcm_reg_id }}
        </sa-info-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Profile
        </mat-panel-title>
        <mat-panel-description>
          <mat-icon>info</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid">
        <sa-info-field label="About">
          {{ user.about }}
        </sa-info-field>
        <sa-info-field label="Height">
          {{ user.height }}
        </sa-info-field>
        <sa-info-field label="Education">
          {{ user.education }}
        </sa-info-field>
        <sa-info-field label="Career">
          {{ user.career }}
        </sa-info-field>
        <sa-info-field label="Languages">
          {{ user.languages }}
        </sa-info-field>
        <sa-info-field label="Looking For">
          {{ user.looking_for }}
        </sa-info-field>
        <sa-info-field label="Favorite Food">
          {{ user.favorite_food }}
        </sa-info-field>
        <sa-info-field label="I Like Someone">
          {{ user.i_like_someone }}
        </sa-info-field>
        <sa-info-field label="Personality">
          {{ user.personality }}
        </sa-info-field>
        <sa-info-field label="Country Born">
          {{ user.country_born }}
        </sa-info-field>
        <sa-info-field label="Drink Pref">
          {{ user.drink_pref }}
        </sa-info-field>
        <sa-info-field label="Smoke Pref">
          {{ user.smoke_pref }}
        </sa-info-field>
        <sa-info-field label="Instagram">
          {{ user.instagram }}
        </sa-info-field>
        <sa-info-field label="TikTok">
          {{ user.tiktok }}
        </sa-info-field>
        <sa-info-field label="Snapchat">
          {{ user.snapchat }}
        </sa-info-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Discovery Settings
        </mat-panel-title>
        <mat-panel-description>
          <mat-icon>person_search</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid">
        <sa-info-field label="Interested In">
          {{ user.interested_in }}
        </sa-info-field>
        <sa-info-field label="Age Range">
          {{ user.min_age }} - {{ user.max_age }}
        </sa-info-field>
        <sa-info-field label="Distance">
          {{ user.range }}
        </sa-info-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Moderation States
        </mat-panel-title>
        <mat-panel-description>
          <mat-icon>shield</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid">
        <sa-info-field label="Waitlisted">
          {{ user.hidden_under_review ? 'Yes' : 'No'}}
        </sa-info-field>
        <sa-info-field label="Banned">
          {{ user.is_banned ? 'Yes' : 'No'}}
        </sa-info-field>
        <sa-info-field label="Silent Hidden">
          {{ user.hidden_silent ? 'Yes' : 'No'}}
        </sa-info-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Location Information
        </mat-panel-title>
        <mat-panel-description>
          <mat-icon>near_me</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid">
        <sa-info-field label="Current Place" *ngIf="user.location_label || user.location">
          {{ user.location_label || user.location }}
        </sa-info-field>
        <sa-info-field label="Last Location" *ngIf="user.last_location?.coordinates">
          <div>
            <google-map [options]="options">
              <map-marker
                [options]="marker"
              >
              </map-marker>
            </google-map>
          </div>
        </sa-info-field>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Record Information
        </mat-panel-title>
        <mat-panel-description>
          <mat-icon>storage</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="container-fluid">
        <sa-info-field label="Created At ({{ timezoneAbbr }})">
          {{ user.createdAt | timezoneDate}}
        </sa-info-field>
        <sa-info-field label="Updated At ({{ timezoneAbbr }})">
          {{ user.updatedAt | timezoneDate}}
        </sa-info-field>
        <sa-info-field label="Deleted At ({{ timezoneAbbr }})">
          {{ user.deletedAt | timezoneDate}}
        </sa-info-field>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

